import { ReactChild } from "react";

export const toChildArray = (
	children: ReactChild[] | ReactChild
): ReactChild[] => {
	if (children.constructor.name === "Array") {
		return children as ReactChild[];
	}
	return [children as ReactChild];
};

export const scrollLoad = (selector: string, callback: () => void) => {
	const intObserver = new IntersectionObserver((entries) => {
		entries.forEach((entry) => {
			if (entry.isIntersecting) {
				!!callback && callback();
			}
		});
	});
	const target = document.querySelector(selector);
	!!target && intObserver.observe(target);
};

export const formatCountTime = (second: number) => {
	let days = Math.floor(second / 86400);
	let hours = Math.floor((second % 86400) / 3600);
	let minutes = Math.floor(((second % 86400) % 3600) / 60);
	let seconds = Math.floor(((second % 86400) % 3600) % 60);

	return { Days: days, Hours: hours, Minutes: minutes, Secs: seconds };
};

export const isPC = () => {
	let userAgent = navigator.userAgent.toLowerCase();
	if (userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
    )) {
		return false;
	} else {
		return true;
	}
};
